import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { pushNotificationService } from "./services/push-notifications";

// Initialize push notifications when app loads
if (typeof window !== 'undefined') {
  pushNotificationService.initialize();
}

createRoot(document.getElementById("root")!).render(<App />);
